<template>
  <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1090;">
    <TransitionGroup name="toast">
      <div v-for="toast in toasts" :key="toast.id"
        class="toast show"
        :class="`toast-${toast.type}`"
        role="alert">
        <div class="toast-header">
          <i :class="['bi', iconClass(toast.type), 'me-2']"></i>
          <strong class="me-auto">{{ toast.title }}</strong>
          <button type="button" class="btn-close" @click="remove(toast.id)"></button>
        </div>
        <div class="toast-body">
          {{ toast.message }}
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const toasts = ref([])
let counter = 0

function iconClass(type) {
  const icons = {
    success: 'bi-check-circle-fill text-success',
    error: 'bi-exclamation-circle-fill text-danger',
    warning: 'bi-exclamation-triangle-fill text-warning',
    info: 'bi-info-circle-fill text-info',
  }
  return icons[type] || icons.info
}

function add(message, type = 'info', title = '', duration = 5000) {
  const id = ++counter
  const toastTitle = title || type.charAt(0).toUpperCase() + type.slice(1)
  toasts.value.push({ id, message, type, title: toastTitle })
  if (duration > 0) {
    setTimeout(() => remove(id), duration)
  }
  return id
}

function remove(id) {
  toasts.value = toasts.value.filter((t) => t.id !== id)
}

function success(message, title = '') { return add(message, 'success', title) }
function error(message, title = 'Error') { return add(message, 'error', title, 8000) }
function warning(message, title = 'Warning') { return add(message, 'warning', title) }
function info(message, title = '') { return add(message, 'info', title) }

defineExpose({ add, remove, success, error, warning, info })
</script>

<style scoped>
.toast-enter-active, .toast-leave-active {
  transition: all 0.3s ease;
}
.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}
.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>
